var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoimg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2243_63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M496.52 129.86C483.09 80.38 431.63 28.93 382.15 15.49C351.82 7.92 311.17 0.13 256 0C200.83 0.14 160.19 7.92 129.85 15.49C80.38 28.93 28.92 80.38 15.49 129.86C7.92 160.19 0.14 200.84 0 256C0.14 311.17 7.92 351.81 15.49 382.15C28.93 431.63 80.38 483.08 129.86 496.52C160.2 504.09 200.84 511.87 256.01 512.01C311.17 511.87 351.82 504.09 382.16 496.52C431.64 483.08 483.09 431.63 496.53 382.15C504.1 351.82 511.88 311.17 512.02 256C511.88 200.83 504.1 160.19 496.53 129.85L496.52 129.86Z",
    fill: "#E6F1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.711 111.91C196.531 109.15 231.131 106.67 256.011 106.95C288.581 106.59 337.811 110.95 355.471 114.48C384.441 120.1 412.451 146.57 418.851 175.46C422.491 193 426.071 216.87 426.131 249.45C426.071 282.03 422.501 305.89 418.851 323.44C417.041 331.6 413.511 339.56 408.721 346.92L173.711 111.91ZM144.221 118.13C120.001 127.74 98.6506 150.7 93.1706 175.45C89.5206 192.99 85.9506 216.86 85.8906 249.44C85.9506 282.02 89.5306 305.88 93.1706 323.43C99.5706 352.32 127.581 378.79 156.551 384.41C174.211 387.94 223.441 392.3 256.011 391.94C288.581 392.3 337.821 387.94 355.471 384.41C368.471 381.89 381.271 375.16 392.011 365.91L144.221 118.13Z",
    fill: "url(#paint0_linear_2243_63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.459 230.66C300.209 224.97 309.969 222.39 319.689 222.35C331.889 222.4 344.169 226.44 352.429 235.63C368.049 253.11 384.269 273.19 398.389 292.26C397.329 301 395.929 309.55 394.159 318.12C393.369 321.6 392.049 325.09 390.289 328.49L292.459 230.66ZM275.209 249.12C259.419 267.75 243.979 287.86 230.639 306.74C222.469 296.17 213.819 285.66 205.199 276.01C199.129 269.26 190.119 266.3 181.159 266.26C172.199 266.3 163.189 269.26 157.119 276.01C144.689 289.92 130.349 307.47 119.199 322.7C125.329 339.87 143.549 356.17 161.349 359.62H161.419L161.489 359.65C175.719 362.49 220.049 366.71 252.129 366.71C253.349 366.71 254.549 366.71 255.719 366.69H256.279C257.459 366.7 258.659 366.71 259.879 366.71C291.969 366.71 336.289 362.49 350.509 359.65H350.579L350.649 359.62C358.769 358.04 366.979 353.79 374.089 348L275.209 249.12Z",
    fill: "url(#paint1_linear_2243_63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.159 234.45C197.435 234.45 210.629 221.256 210.629 204.98C210.629 188.704 197.435 175.51 181.159 175.51C164.884 175.51 151.689 188.704 151.689 204.98C151.689 221.256 164.884 234.45 181.159 234.45Z",
    fill: "url(#paint2_linear_2243_63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.711 111.91C195.371 109.29 227.641 106.93 252.131 106.93C253.441 106.93 254.741 106.93 256.001 106.95C257.271 106.94 258.561 106.93 259.881 106.93C292.361 106.93 338.491 111.09 355.461 114.48C384.431 120.1 412.441 146.57 418.841 175.46C422.481 193 426.061 216.87 426.121 249.45C426.061 282.03 422.491 305.89 418.841 323.44C417.031 331.6 413.501 339.56 408.711 346.92L390.281 328.49C392.041 325.09 393.371 321.6 394.151 318.12C398.681 296.24 400.821 274.41 400.861 249.45C400.821 224.51 398.681 202.68 394.151 180.78C389.921 162.02 370.031 143.03 350.651 139.27H350.581L350.511 139.24C336.281 136.4 291.961 132.18 259.881 132.18H259.851C258.641 132.18 257.451 132.18 256.281 132.2H255.721C254.521 132.188 253.321 132.181 252.121 132.18C234.991 132.18 214.381 133.38 196.721 134.93L173.701 111.91H173.711ZM374.091 348C366.981 353.79 358.771 358.04 350.651 359.62H350.581L350.511 359.65C336.291 362.49 291.961 366.71 259.881 366.71C258.661 366.71 257.461 366.71 256.281 366.69H255.721C254.541 366.7 253.351 366.71 252.131 366.71C220.051 366.71 175.721 362.49 161.491 359.65H161.421L161.351 359.62C141.971 355.86 122.081 336.88 117.851 318.11C113.321 296.21 111.181 274.38 111.141 249.44C111.191 224.46 113.321 202.63 117.851 180.77C122.081 162.01 141.971 143.02 161.351 139.26H161.421L161.491 139.23C162.441 139.04 163.531 138.84 164.731 138.64L144.211 118.12C119.991 127.73 98.6409 150.69 93.1609 175.44C89.5109 192.98 85.9409 216.85 85.8809 249.43C85.9409 282.01 89.5209 305.87 93.1609 323.42C99.5609 352.31 127.571 378.78 156.541 384.4C173.511 387.79 219.651 391.95 252.131 391.95C253.451 391.95 254.731 391.95 256.001 391.93C257.271 391.94 258.561 391.95 259.871 391.95C292.351 391.95 338.491 387.79 355.451 384.4C368.451 381.88 381.251 375.15 391.991 365.9L374.081 347.99L374.091 348Z",
    fill: "url(#paint3_linear_2243_63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.33 417.71C410.1 417.71 406.87 416.48 404.4 414.01L106.25 115.85C101.32 110.92 101.32 102.93 106.25 98C111.18 93.07 119.17 93.07 124.1 98L422.26 396.16C427.19 401.09 427.19 409.08 422.26 414.01C419.79 416.48 416.56 417.71 413.33 417.71Z",
    fill: "url(#paint4_linear_2243_63)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2243_63",
    x1: 348.441,
    y1: 341.88,
    x2: 95.7806,
    y2: 89.2201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCE4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2243_63",
    x1: 337.619,
    y1: 384.48,
    x2: 193.119,
    y2: 239.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13B601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#13B601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#5BCE47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ABE995"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBF4B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2243_63",
    x1: 201.999,
    y1: 225.82,
    x2: 160.319,
    y2: 184.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FE7636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#FFAD8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2243_63",
    x1: 382.241,
    y1: 375.68,
    x2: 76.2408,
    y2: 69.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34344F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#666684"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2243_63",
    x1: 382.24,
    y1: 375.68,
    x2: 76.2402,
    y2: 69.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34344F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#666684"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2243_63"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoimg);
export default __webpack_public_path__ + "static/media/noimg.6e4e2e3ebc5ace53b2d92815763dc06a.svg";
export { ForwardRef as ReactComponent };